// extracted by mini-css-extract-plugin
export default {"inputs":"CreditReport_inputs__dSF4m","consent":"CreditReport_consent__i-+rd","checkbox":"CreditReport_checkbox__EnLKC"};